import React from 'react';
import { Box, Typography, Paper, Grid, Button, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { CloudDownload, Send, Code } from '@mui/icons-material';

const ExportDeploy: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Export & Deploy</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Export configurations in various formats and deploy to devices
      </Typography>
      
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Export Options</Typography>
            <Stack spacing={2}>
              <FormControl fullWidth>
                <InputLabel>Export Format</InputLabel>
                <Select label="Export Format" defaultValue="text">
                  <MenuItem value="text">Plain Text</MenuItem>
                  <MenuItem value="json">JSON</MenuItem>
                  <MenuItem value="yaml">YAML</MenuItem>
                  <MenuItem value="tftp">TFTP Script</MenuItem>
                </Select>
              </FormControl>
              <Button variant="contained" startIcon={<CloudDownload />}>
                Export Configuration
              </Button>
            </Stack>
          </Paper>
        </Grid>
        
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Deployment Options</Typography>
            <Stack spacing={2}>
              <Button variant="outlined" startIcon={<Send />}>
                Deploy via SSH
              </Button>
              <Button variant="outlined" startIcon={<Code />}>
                Generate Ansible Playbook
              </Button>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ExportDeploy;